import * as React from 'react';
import { AnalyticsContext } from './AnalyticsContext';

const useAnalytics = (): {
  service: Bluebeam.Services.IAnalyticsService;
} => {
  const context = React.useContext(AnalyticsContext);

  if (!context) {
    throw new Error(
      '`useAnalytics` must be used within a <AnalyticsContext.Provider />'
    );
  }

  return { service: context };
};

export { useAnalytics };
